export interface ItemPickerSettingsModel {
	allowMultiSelection: boolean;
	title: string;
	placeholder: string;
}
